export default __webpack_public_path__ + "static/media/rv-img.6c6221ce.png";